import type { Moment } from 'moment'

export enum FilterCategory {
  story = 'story',
  channel = 'channel',
  labelSet = 'labelSet',
  workflowStatus = 'workflowStatus',
  date = 'date',
}

export type FilterOption = {
  divider: boolean
  groupOrAble: boolean
  id: string
  inclusivity: boolean
  title: string
  payload?: FilterPayload
  uuid?: string
  childOptions?: Array<FilterOption>
  color?: string
  icon?: string
  gemIcon?: string
  type?: string
  // ancestors is here to support the flattened set
  // of filter options
  ancestors?: Array<FilterOption>
}

/**
 * This object is passed along with the FilterBar's onChange callback
 * and is accessed in a variety of ways to massage the filter state
 * into something relevant for the page or API doing the filtering.
 */
export type OnChangeMetaValue = {
  disabled: boolean
  value: {
    disabled: Array<FilterOption['id']>
    selected: Array<FilterOption['id']>
    filterValues: Record<string, unknown>
  }
}

export type FilterOptions = Array<FilterOption>

export type FilterPayload =
  | {
      type_key: 'services_and_accounts'
      object: { id: string | number; _id?: number; service_id?: number }
    }
  | { type_key: 'labels'; object: { id: number; label_set_id: number } }
  | { type_key: 'statuses'; object: { status: string } }
  | { type_key: 'duration'; object: { key: string; value: Moment } }
  | { type_key: 'stories'; object: { id: number } }

export const isFilterOption = (
  filterOption: FilterOption | null
): filterOption is FilterOption => filterOption !== null
